(function initCartoonCalendarRenderer() {
  function renderCartoonCalendarOffer({ petName, submissionImageUrl, offerAssembly, dogId } = {}) {
    const submissionPhotoSlot = document.querySelector('.submission-photo-slot');

    // Replace pet name in the designated element
    if (petName) {
      const petNameElement = document.querySelector('.replace-pet-name > .gp-p-description-text > h4') || document.querySelector('.replace-pet-name > .gp-p-description-text > p');
      if (petNameElement) {
        console.log(petNameElement);
        petNameElement.style.fontWeight = '400';
        petNameElement.innerHTML = petNameElement.innerHTML
          .replace(/your pet/gi, `<em><strong>${petName}</strong></em>`)
          .replace(/every single month/gi, `<u>every single month</u>`);
      }
    }

    if (submissionImageUrl && submissionPhotoSlot) {
      submissionPhotoSlot.innerHTML = '';

      const imageElement = document.createElement('img');
      imageElement.src = submissionImageUrl;
      imageElement.fetchPriority = 'high';
      imageElement.width = 125;
      imageElement.height = 125;
      imageElement.style.width = '125px';
      imageElement.style.height = '125px';
      imageElement.style.objectFit = 'cover';
      imageElement.style.borderRadius = '8px';
      imageElement.setAttribute('srcset', submissionImageUrl);

      submissionPhotoSlot.appendChild(imageElement);
    }

    const productImgEl = document.querySelector('img.gp-w-full.gp-h-full.gp-absolute.gp-top-0.gp-left-0.featured-image-only');

    console.log('Dog ID for cartoon calendar:', dogId);

    // Relace Default Photo If Needed
    if (!dogId || dogId.trim() === '') {
      console.log('No dog ID provided, using default cartoon calendar image.');

      const defaultProductImageUrl =
        'https://thepawprint.store/cdn/shop/files/January_2026_Cartoon_Calendar.png?v=1765395249&width=1620';

      if (productImgEl) {
        productImgEl.src = defaultProductImageUrl;
        productImgEl.setAttribute('srcset', defaultProductImageUrl);
        console.log('Set default cartoon calendar image for no dog ID.');
      }
    }

    // Setup product photo
    console.log('offerAssembly for cartoon calendar:', offerAssembly);
    const imageFile = offerAssembly ? offerAssembly.image_files_used_cropped?.[0] || offerAssembly.image_files_used?.[0] : null;

    if (productImgEl && imageFile) {
      addDogIdHiddenCSS();

      // Create and show loader
      const loaderId = "cartoon-calendar-main-loader";
      const parent = productImgEl.parentElement;
      if (parent) {
        if (!document.querySelector(`#${loaderId}`)) {
          const loader = document.createElement("div");
          loader.id = loaderId;
          loader.className = "loader";
          loader.style.position = "absolute";
          loader.style.top = "calc(50% - 28px)";
          loader.style.left = "calc(50% - 28px)";
          loader.style.transform = "translate(-50%, -50%)";
          loader.style.margin = "0";
          loader.style.zIndex = "9998";

          const parentPosition = window.getComputedStyle(parent).position;
          if (parentPosition === "static" || !parentPosition) {
            parent.style.position = "relative";
          }

          parent.appendChild(loader);
        }
      }

      // Clear src and srcset before loading new image
      productImgEl.removeAttribute('src');
      productImgEl.removeAttribute('srcset');

      const cloudinaryUrl = `https://res.cloudinary.com/da9yd4bgx/image/fetch/t_cartoon-calendar-p5/w_730/f_webp/${encodeURIComponent(imageFile)}`;

      // Set up load handler to remove loader
      const handleImageLoad = () => {
        const loaderElement = document.querySelector(`#${loaderId}`);
        if (loaderElement) {
          loaderElement.remove();
        }
        productImgEl.removeEventListener('load', handleImageLoad);
      };

      productImgEl.addEventListener('load', handleImageLoad);
      productImgEl.src = cloudinaryUrl;
      productImgEl.setAttribute('srcset', cloudinaryUrl);
      productImgEl.fetchPriority = 'high';

      setTimeout(() => {
        overlayImageOnTarget({
          targetSelector:
            'img.gp-w-full.gp-h-full.gp-absolute.gp-top-0.gp-left-0.featured-image-only',
          overlayUrl: offerAssembly?.submission_images_cropped?.[0] || submissionImageUrl || offerAssembly?.submission_images?.[0],
          sizePercent: 0.35,   // 20%
          offsetPercentX: 0,  // 10%
          offsetPercentY: 0.09  // 10%
        });
      }, 100);
    }

    return () => { };
  }

  function overlayImageOnTarget(options) {
    const overlayId = "cartoon-calendar-overlay-image";

    if (document.querySelector(`#${overlayId}`)) {
      return;
    }

    const {
      targetSelector,
      overlayUrl,
      sizePercent = 0.20,   // 20% of the original image size
      offsetPercentX = 0,  // 10% offset from top/left
      offsetPercentY = 0.10  // 10% offset from top/left
    } = options;

    const originalImg = document.querySelector(targetSelector);
    if (!originalImg) {
      console.warn("Target image not found:", targetSelector);
      return;
    }

    const overlayImg = document.createElement("img");
    overlayImg.src = `https://res.cloudinary.com/da9yd4bgx/image/fetch/w_300/f_webp/${encodeURIComponent(overlayUrl)}`;
    overlayImg.id = overlayId;

    const parent = originalImg.parentElement;
    if (parent) {
      const computedParentPosition = window.getComputedStyle(parent).position;
      if (computedParentPosition === "static" || !computedParentPosition) {
        parent.style.position = "relative";
      }
    }

    // Create and show loader

    const placeOverlay = () => {
      const w = originalImg.clientWidth;
      const h = originalImg.clientHeight;

      // Use the smaller dimension so the square fits nicely relative
      // to the original image size.
      const base = Math.min(w, h);
      const side = base * sizePercent;

      overlayImg.style.width = side + "px";
      overlayImg.style.height = side + "px";

      overlayImg.style.position = "absolute";
      overlayImg.style.left = (w * offsetPercentX) + "px";
      overlayImg.style.top = (h * offsetPercentY) + "px";

      // Aspect-fill behavior
      overlayImg.style.objectFit = "cover";     // crop instead of stretch
      overlayImg.style.objectPosition = "center"; // center the crop

      overlayImg.style.pointerEvents = "none";
      overlayImg.style.zIndex = "9999";
    };

    const setupLoadedUI = () => {
      if (parent) {
        parent.appendChild(overlayImg);
      }

      placeOverlay();

      let attempts = 0;
      const overlayInterval = setInterval(() => {
        placeOverlay();
        attempts++;
        if (attempts >= 50) {
          clearInterval(overlayInterval);
        }
      }, 100);

      window.addEventListener("resize", placeOverlay);
    };

    if (originalImg.complete) {
      setupLoadedUI();
    } else {
      originalImg.onload = () => {
        setupLoadedUI();
      };
    }
  }

  function addDogIdHiddenCSS() {
    const style = document.createElement('style');
    style.textContent = `
    .dog-id-hidden {
      display: none !important;
    }
  `;
    document.head.appendChild(style);
  }

  window.renderCartoonCalendarOffer = renderCartoonCalendarOffer;
})();
